import pizzaImg01 from "./assets/pizza1.png";
import fastFood03 from "./assets/chicken3.png";
import fastFood04 from "./assets/chicken4.png";
import dessert02 from "./assets/dessert02.png";

// import dessert03 from "./assets/dessert2.png";
// import dessert04 from "./assets/dessert3.png";
// import coffeeImg02 from "./assets/coffe2.png";

export const popularMenuFood = [
  {
    id: "01",
    title: "Vegetable Salad",
    price: 25,
    imgURL: fastFood03,
    foodDesc: "Best pizza in the world",
    stars: 5,
  },
  {
    id: "02",
    title: "Chicken",
    price: 250,
    imgURL: fastFood04,
    foodDesc: "Best pizza in the world",
    stars: 5,
  },

  {
    id: "03",
    title: "Whipped Cream",
    price: 45,
    imgURL: dessert02,
    foodDesc: "Best pizza in the world",
    stars: 5,
  },

  {
    id: "04",
    title: "Pizza",
    price: 75,
    imgURL: pizzaImg01,
    foodDesc: "Best pizza in the world",
    stars: 5,
  },
];
